import { waitForLastElement } from "../dom";

function unwrap(actions, query, id, document = window.document) {
  if (!query || !actions) {
    return;
  }

  id = id ?? query.getEvent("selected").first();
  if (!id) return;

  // Check if selected node is canvas
  if (!query.node(id).isCanvas()) {
    return;
  }

  var containerID = id;
  var childrens = query.node(containerID)?.childNodes() ?? [];

  const parents = query.node(containerID).ancestors();
  var node_parent = undefined;
  var node_index = undefined;
  if (parents && parents.length > 0) {
    node_parent = parents[0];
  }
  if (node_parent) {
    // Return if parent is not canvas
    if (!query.node(node_parent).isCanvas()) {
      return;
    }

    let parentChildrens = query.node(node_parent).childNodes();
    node_index = parentChildrens.indexOf(containerID) + 1;
  }

  actions.move(childrens, node_parent, node_index);

  actions.delete(containerID);

  waitForLastElement(
    document,
    `[data-grigora-block-id="${childrens[0]}"]`,
  ).then((elm) => {
    actions.selectNode(childrens[0]);
  });
}

export default unwrap;
